import { ConfigService } from './config.service';
import { ApplicationTypeToken } from './environment.constant';

export function loadConfiguration(
  appConfigService: ConfigService,
  applicationTypeToken: ApplicationTypeToken,
): () => Promise<boolean> {
  return () => appConfigService.getConfig(applicationTypeToken);
}

export function loadLanguages(appConfigService: ConfigService): () => Promise<boolean> {
  return () => appConfigService.loadLanguages();
}

export function getLanguages(appConfigService: ConfigService): string[] {
  return appConfigService.getLanguages();
}
